import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Alert,
} from '@mui/material';
import {
  Lock,
  Home,
  ArrowBack,
} from '@mui/icons-material';

export default function UnauthorizedPage() {
  const { t } = useTranslation('auth');
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get the previous page from navigation state
  const attemptedPath = location.state?.from?.pathname;
  
  const handleGoToDashboard = () => {
    navigate('/home', { replace: true });
  };
  
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f8fafc',
        padding: 2,
      }}
    >
      <Card elevation={3} sx={{ maxWidth: 500, width: '100%' }}>
        <CardContent sx={{ p: 4, textAlign: 'center' }}>
          {/* Icon */}
          <Box
            sx={{
              width: 80,
              height: 80,
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #ef4444, #f97316)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mx: 'auto',
              mb: 3,
            }}
          >
            <Lock sx={{ fontSize: 40, color: 'white' }} />
          </Box>
          
          {/* Main heading */}
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            {t('auth:permissions.access_denied_title')}
          </Typography>
          
          {/* Subheading */}
          <Typography variant="h6" color="text.secondary" paragraph>
            {t('auth:permissions.access_denied')}
          </Typography>
          
          {/* Alert with more details */}
          <Alert severity="warning" sx={{ mb: 3, textAlign: 'left' }}>
            <Typography variant="body2">
              <strong>{t('auth:permissions.what_happened')}</strong><br />
              {t('auth:permissions.requires_permissions')}
            </Typography>
          </Alert>
          
          {/* Current path info */}
          {attemptedPath && (
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              {t('auth:permissions.attempted_access')}: <code>{attemptedPath}</code>
            </Typography>
          )}
          
          {/* Action buttons */}
          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Button
              variant="contained"
              startIcon={<Home />}
              onClick={handleGoToDashboard}
              size="large"
            >
              {t('auth:permissions.go_back')}
            </Button>
          </Box>
          
          {/* Help text */}
          <Typography variant="caption" color="text.secondary" sx={{ mt: 3, display: 'block' }}>
            {t('auth:permissions.contact_admin')}
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}